import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "calendar" };
const _hoisted_2 = { class: "modeChanger" };
const _hoisted_3 = { class: "navigatorContainer" };
const _hoisted_4 = { class: "month" };
const _hoisted_5 = { class: "weekDaysContainer" };
const _hoisted_6 = { class: "calendarDaysContainer" };
const _hoisted_7 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.setMode('month')))
            }, "MESE"),
            _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.setMode('week')))
            }, "SETTIMANA")
        ]),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
                class: "prev",
                onClick: _cache[2] || (_cache[2] =
                    //@ts-ignore
                    (...args) => (_ctx.goNext && _ctx.goNext(...args)))
            }, _cache[4] || (_cache[4] = [
                _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
            ])),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.currentWeek), 1),
            _createElementVNode("div", {
                class: "next",
                onClick: _cache[3] || (_cache[3] =
                    //@ts-ignore
                    (...args) => (_ctx.goPrev && _ctx.goPrev(...args)))
            }, _cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
            ]))
        ]),
        _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (giorno, i) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "weekDay",
                    key: i
                }, [
                    _createElementVNode("b", null, _toDisplayString(giorno), 1)
                ]));
            }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, i) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["calendarDay", day.classes]),
                    key: i
                }, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$filters.date(day.date, 'DD')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getItemsOfDate(day.date), (item, ii) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: "label pointer",
                            key: ii,
                            onClick: ($event) => (_ctx.clicked(item))
                        }, _cache[6] || (_cache[6] = [
                            _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                        ]), 8, _hoisted_7));
                    }), 128))
                ], 2));
            }), 128))
        ])
    ]));
}
